import { render, staticRenderFns } from "./Cross.vue?vue&type=template&id=280ad53c&scoped=true&"
import script from "./Cross.vue?vue&type=script&lang=js&"
export * from "./Cross.vue?vue&type=script&lang=js&"
import style0 from "./Cross.vue?vue&type=style&index=0&id=280ad53c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280ad53c",
  null
  
)

export default component.exports